import React from 'react';
import Grid from '@mui/material/Grid';
import { useTranslation } from 'react-i18next';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

import LabeledCustomSelect from 'components/elements/LabeledCustomSelect';
import CustomTooltip from 'components/elements/CustomTooltip';

const FilterLabel = ({ label }) => {
  return (
    <CustomTooltip title={label}>
      <Typography
        sx={{
          fontSize: '0.875rem',
          color: '#989898',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          lineHeight: '21px',
          maxHeight: '24px',
          whiteSpace: 'nowrap',
        }}
      >
        {label}
      </Typography>
    </CustomTooltip>
  );
};

const Filters = ({
                   filters = {
                     segment: '',
                     xAxis: '',
                     yAxis: '',
                     program: 'all',
                   },
                   segments = [],
                   xAxis = [],
                   yAxis = [],
                   programs = [],
                   setFilters = () => {},
                   view = '',
                   handleSwitch = () => {},
                 }) => {
  const { t } = useTranslation();

  const viewChart = [
    {
      id: 'twoD',
      name: '2 dimensions',
      value: 'twoD',
    },
    {
      id: 'oneD',
      name: '1 dimensional',
      value: 'oneD',
    },
  ];

  const selectStyles = {
    backgroundColor: '#fff',
    '.MuiOutlinedInput-notchedOutline': {
      top: 0,
      legend: { display: 'none' },
    },
    '.MuiInputBase-input': {
      fontSize: '0.875rem !important',
    },
    minWidth: '120px', // Ensure minimum width
  };

  return (
    <Box sx={{ width: '100%', overflow: 'hidden' }}>
      <Grid container spacing={2} sx={{ flexWrap: { xs: 'wrap', lg: 'nowrap' } }}>
        {/* Segment Filter */}
        <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
          <Grid container spacing={0.5}>
            <Grid item xs={12}>
              <FilterLabel label={t('feature.evaluate.summary.filters.segment')} />
            </Grid>
            <Grid item xs={12}>
              <LabeledCustomSelect
                sx={selectStyles}
                id="select-segment"
                name="segment"
                height="20em"
                selectItems={segments}
                emptyPlaceholder={true}
                value={filters.segment}
                onChange={(e) => {
                  setFilters({
                    ...filters,
                    segment: e.target.value,
                  });
                }}
              />
            </Grid>
          </Grid>
        </Grid>

        {/* Main Filters Container */}
        <Grid item xs={12} sm={12} md={8} lg={9} xl={10}>
          <Grid container spacing={2}>
            {/* X-Axis Filter */}
            <Grid item xs={12} sm={6} md={3} lg={3}>
              <Grid container spacing={0.5}>
                <Grid item xs={12}>
                  <FilterLabel label={t('feature.evaluate.summary.filters.xAxis')} />
                </Grid>
                <Grid item xs={12}>
                  <LabeledCustomSelect
                    sx={selectStyles}
                    id="select-xAxis"
                    name="xAxis"
                    emptyPlaceholder={true}
                    selectItems={xAxis}
                    value={filters.xAxis}
                    onChange={(e) => {
                      setFilters({
                        ...filters,
                        xAxis: e.target.value,
                        ...(filters.yAxis === e.target.value && { yAxis: filters.xAxis }),
                      });
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>

            {/* Y-Axis Filter */}
            <Grid item xs={12} sm={6} md={3} lg={3}>
              <Grid container spacing={0.5}>
                <Grid item xs={12}>
                  <FilterLabel label={t('feature.evaluate.summary.filters.yAxis')} />
                </Grid>
                <Grid item xs={12}>
                  <LabeledCustomSelect
                    sx={selectStyles}
                    id="select-yAxis"
                    name="yAxis"
                    emptyPlaceholder={true}
                    selectItems={yAxis}
                    value={filters.yAxis}
                    onChange={(e) => {
                      setFilters({
                        ...filters,
                        yAxis: e.target.value,
                        ...(filters.xAxis === e.target.value && { xAxis: filters.yAxis }),
                      });
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>

            {/* Program Filter */}
            <Grid item xs={12} sm={6} md={3} lg={3}>
              <Grid container spacing={0.5}>
                <Grid item xs={12}>
                  <FilterLabel label={t('feature.evaluate.summary.filters.program') || 'Program'} />
                </Grid>
                <Grid item xs={12}>
                  <LabeledCustomSelect
                    sx={selectStyles}
                    id="select-program"
                    name="program"
                    emptyPlaceholder={true}
                    selectItems={programs}
                    value={filters.program}
                    onChange={(e) => {
                      setFilters({ ...filters, program: e.target.value });
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>

            {/* View Chart Filter */}
            <Grid item xs={12} sm={6} md={3} lg={3}>
              <Grid container spacing={0.5}>
                <Grid item xs={12}>
                  <FilterLabel label={t('feature.evaluate.summary.filters.viewChart')} />
                </Grid>
                <Grid item xs={12}>
                  <LabeledCustomSelect
                    sx={selectStyles}
                    id="select-view"
                    name="viewChart"
                    emptyPlaceholder={true}
                    selectItems={viewChart}
                    value={view}
                    onChange={(e) => {
                      handleSwitch(e.target.value);
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Filters;